module.exports = __webpack_public_path__ + "img/img_G1.3.3.92ec439e.png";